import { runChineseLesson } from '../chinese-lesson';
import type { LearnDoneCallback } from '../app';

/**
 * KP `chinese.idiom.basic` — 三下「成語故事與應用」。
 * Underlying bank: public/data/chinese-idiom-康軒.json (already shipped).
 * Wrapper provides a stable entry point matching the other lesson modules
 * in this folder, so main.ts can dispatch by KP id uniformly.
 */
export function runChineseIdiomBasicLesson(container: HTMLElement, onDone: LearnDoneCallback): Promise<void> {
  return runChineseLesson(container, 'chinese.idiom.basic', onDone);
}
